import { useState, useEffect, useCallback } from 'react';
import { useSpring } from 'react-spring';
var QUERY = '(prefers-reduced-motion: no-preference)';
var getInitialState = function () {
  return typeof window === 'undefined' ? true : !window.matchMedia(QUERY).matches;
};
var usePrefersReducedMotion = function () {
  var _a = useState(getInitialState),
    reduceMotion = _a[0],
    setReduceMotion = _a[1];
  useEffect(function () {
    var mediaQueryList = window.matchMedia('(prefers-reduced-motion: no-preference)');
    var listener = function (event) {
      setReduceMotion(!event.matches);
    };
    mediaQueryList.addEventListener('change', listener);
    return function () {
      return mediaQueryList.removeEventListener('change', listener);
    };
  }, []);
  return reduceMotion;
};
var useBoop = function (_a) {
  var _b = _a === void 0 ? {} : _a,
    _c = _b.x,
    x = _c === void 0 ? 0 : _c,
    _d = _b.y,
    y = _d === void 0 ? 0 : _d,
    _e = _b.z,
    z = _e === void 0 ? 0 : _e,
    _f = _b.rotation,
    rotation = _f === void 0 ? 0 : _f,
    _g = _b.rx,
    rx = _g === void 0 ? 0 : _g,
    _h = _b.ry,
    ry = _h === void 0 ? 0 : _h,
    _j = _b.rz,
    rz = _j === void 0 ? rotation : _j,
    _k = _b.scale,
    scale = _k === void 0 ? 1 : _k,
    _l = _b.sx,
    sx = _l === void 0 ? scale || 1 : _l,
    _m = _b.sy,
    sy = _m === void 0 ? scale || 1 : _m,
    _o = _b.sz,
    sz = _o === void 0 ? scale || 1 : _o,
    _p = _b.skewX,
    skewX = _p === void 0 ? 0 : _p,
    _q = _b.skewY,
    skewY = _q === void 0 ? 0 : _q,
    _r = _b.timing,
    timing = _r === void 0 ? 150 : _r,
    _s = _b.springConfig,
    springConfig = _s === void 0 ? {
      tension: 300,
      friction: 10
    } : _s,
    _t = _b.delay,
    delay = _t === void 0 ? 0 : _t;
  var prefersReducedMotion = usePrefersReducedMotion();
  var _u = useState(false),
    isBooped = _u[0],
    setIsBooped = _u[1];
  var _v = useState(false),
    isTriggered = _v[0],
    setIsTriggered = _v[1];
  var style = useSpring(prefersReducedMotion ? {} : {
    transform: isBooped ? "translate3D(" + x + "px, " + y + "px, " + z + "px)\n         rotateX(" + rx + "deg) rotateY(" + ry + "deg) rotateZ(" + rz + "deg)\n         scale3D(" + sx + "," + sy + "," + sz + ")\n         skew(" + skewX + "deg, " + skewY + "deg)" : "translate3D(0px, 0px, 0px)\n         rotateX(0deg) rotateY(0deg) rotateZ(0deg)\n         scale3D(1, 1, 1)\n         skew(0deg, 0deg)",
    config: springConfig,
    immediate: prefersReducedMotion
  });
  var trigger = useCallback(function () {
    if (!prefersReducedMotion) {
      setIsTriggered(true);
    }
  }, [prefersReducedMotion]);
  useEffect(function () {
    if (!isTriggered) return;
    var timeoutId = window.setTimeout(function () {
      setIsBooped(true);
      setIsTriggered(false);
    }, delay);
    return function () {
      return window.clearTimeout(timeoutId);
    };
  }, [isTriggered, delay]);
  useEffect(function () {
    if (!isBooped) return;
    var timeoutId = window.setTimeout(function () {
      return setIsBooped(false);
    }, timing);
    return function () {
      return window.clearTimeout(timeoutId);
    };
  }, [isBooped, timing]);
  return [style, trigger];
};
export default useBoop;